import { Component, OnInit, ElementRef, NgZone, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
//import { NetworkServicesService } from 'src/app/networkCalls/network-services.service';
import { Title, Meta } from '@angular/platform-browser';
// import { katanaInput } from 'src/app/models/katana-input.service';
// import { katanaResult } from 'src/app/models/katana-result.service';
// import { CKEditorComponent } from 'ngx-ckeditor';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
// import { FeedbackModalComponent } from 'src/app/Components/feedback-modal/feedback-modal.component';
// import { Observable, from } from 'rxjs';
// import { MatDialog } from '@angular/material';
// import { ErrorModalComponent } from '../error-modal/error-modal.component';
// import { ProgressStatusService } from '../../services/progress-status-service'
//import { rejectError } from 'src/app/models/reject-suggetions.service';
// import { NGXLogger } from 'ngx-logger';
//import { acceptError } from 'src/app/models/accept-suggetions.service';
//import { trigger, transition, style } from '@angular/animations';
// import { $ } from 'protractor';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
//import { MatRadioChange } from '@angular/material/radio';
//import { MatSnackBar } from '@angular/material/snack-bar';
//import { start } from 'repl';
// import { MatDialog } from '@angular/material/dialog';
// import { NoopScrollStrategy } from '@angular/cdk/overlay'
// import { DetectionLimitExhaustModalComponent } from '../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component';
// import { EnglishGrammarCheckerComponent } from 'src/app/Components/english-grammar-checker/english-grammar-checker.component';
// import { environment } from 'src/environments/environment';

//declare function ire(string,{}): any;
@Component({
  selector: 'app-spell-checker',
  templateUrl: './spell-checker.component.html',
  styleUrls: ['./spell-checker.component.scss']
})
export class SpellCheckerComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    // public dialog: MatDialog,
    // public progressStatusService: ProgressStatusService,
    // private errorModalComponent: ErrorModalComponent,
    public lc: NgZone,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
    // private logger: NGXLogger,
  ) {
   // window.addEventListener("message", (d)=>{this.listenWindowMessage(d)});
    this.document.body.classList.add('nosnipptFooter');
  }

  ngOnInit() {
    // ele.classList.remove("loading")
    this.titleService.setTitle("無料オンラインスペルチェッカー | AI英文校正ツールTrinka");
    this.metaTagService.updateTag({ name: 'description', content: "Trinkaの無料オンラインスペルチェッカーで、英語のスペルミスや文法ミスを即座に修正。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "無料オンラインスペルチェッカー | AI英文校正ツールTrinka" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinkaの無料オンラインスペルチェッカーで、英語のスペルミスや文法ミスを即座に修正。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/spell-checker' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/jp/assets/images/LearnGrammarwithTrinka.png' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '無料オンラインスペルチェッカー | AI英文校正ツールTrinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinkaの無料オンラインスペルチェッカーで、英語のスペルミスや文法ミスを即座に修正。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://trinka.ai/assets/images/LearnGrammarwithTrinka.png' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/spell-checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/spell-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/corrector-ortografico' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/spell-checker' });
    if (isPlatformBrowser(this.platformId)) {

      if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        $("#GCChromeButton2").css("display", "none");
        $("#GCFirFoxButton2").css("display", "none");
        $("#GCEdgeButton2").css("display", "none");
        return 'Opera';

      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        console.log("cgrome")
        $("#GCChromeButton2").css("display", "block");
        $("#GCFirFoxButton2").css("display", "none");
        $("#GCEdgeButton2").css("display", "none");
        return 'Chrome';

      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        $("#GCChromeButton2").css("display", "none");
        $("#GCFirFoxButton2").css("display", "none");
        $("#GCEdgeButton2").css("display", "none");

        return 'Safari';

      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        $("#GCChromeButton2").css("display", "none");
        $("#GCFirFoxButton2").css("display", "block");
        $("#GCEdgeButton2").css("display", "none");
        return 'Firefox';

      }
      else if ((navigator.userAgent.indexOf("MSIE") != -1)) {
        $("#GCChromeButton2").css("display", "none");
        $("#GCFirFoxButton2").css("display", "none");
        $("#GCEdgeButton2").css("display", "block");
        return 'IE';
      }
      else {
        return 'unknown';
      }
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  ngOnDestroy() {
    this.document.body.classList.remove('nosnipptFooter');
  }

  
}
